import React from 'react';
import { Route, Switch } from 'react-router-dom';

// components
import SidePanel from 'sidePanel/components/SidePanel';

// constants
import routesConfig from 'constants/routesConfig.json';

function SidePanelRoutes(): JSX.Element {
  return (
    <Switch>
      <Route exact path={routesConfig.CONVO_PAGE}>
        <SidePanel />
      </Route>
      <Route path={`${routesConfig.CONVO_PAGE}/:id`}>
        <SidePanel />
      </Route>
      <Route exact path={routesConfig.TEAM_PAGE}>
        <SidePanel />
      </Route>
      <Route path={`${routesConfig.TEAM_PAGE}/:id`}>
        <SidePanel />
      </Route>
      <Route path="*">
        <SidePanel />
      </Route>
    </Switch>
  );
}

export default SidePanelRoutes;
